import { combineReducers } from 'redux';
import matchdayListReducer from './matchday-list.slice'
import voteListReducer from './vote-list.slice'

const rootReducer = combineReducers({
    list: matchdayListReducer,
    votes: voteListReducer
});

export default rootReducer;